import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useAuthStore = create()(persist((set)=>({
        token: null,
        userID: null,
        username: null,
        role: null,
        email: null,
        isAuthenticated: false,
        isAdmin: false,
        login: (token, userID, username, role, email)=>set({
                token,
                userID,
                username,
                role,
                email,
                isAuthenticated: true,
                isAdmin: role === 'admin'
            }),
        logout: ()=>set({
                token: null,
                userID: null,
                username: null,
                role: null,
                email: null,
                isAuthenticated: false,
                isAdmin: false
            })
    }), {
    name: 'shirt-site-auth'
}));
